import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=0c8ac235&scoped=true&"
import script from "./topbar.vue?vue&type=script&lang=js&"
export * from "./topbar.vue?vue&type=script&lang=js&"
import style0 from "./topbar.vue?vue&type=style&index=0&id=0c8ac235&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ac235",
  null
  
)

export default component.exports